import abTestManager from "abba";
import Bridge from "bridge-web";
import Client from "shared/services/Client";
import appConfig from "utils/appConfig";

export default {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getConfig(subscriberData: AbbaUserInfo): Promise<AbbaConfig> {
        return Client.get(`${ appConfig().abbaTargetUrl }/${ appConfig().abbaPlatformIdentifier }`, { external: true })
            .then((targets) => {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
                const bridge: typeof Bridge = new Bridge();

                // eslint-disable-next-line max-len
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
                return abTestManager.getConfig({ targets }, bridge, subscriberData);
            });
    }
};
